// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__a3mxT","title":"Header_title__3VzTp","left":"Header_left__J04LH","clinicName":"Header_clinicName__2Td02"};